import { useState, useEffect } from 'react';

/**
 * Listens to the Page Visibility API and returns whether the app is in the foreground.
 * Returns true when the document is visible, false when hidden (e.g. tab switched, window minimized).
 */
export function useAppInForeground(): boolean {
  const [isInForeground, setIsInForeground] = useState(() =>
    typeof document !== 'undefined' ? document.visibilityState === 'visible' : true,
  );

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsInForeground(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return isInForeground;
}
